// Privacy-conscious event tracking: platform analytics plus the app's own
// non-sensitive event log. Never send answers, scores, or report content.
const post = (event, properties) => {
  import("./api").then(({ api }) => {
    api.post("/track", { event, properties }).catch(() => {});
  });
};

export const track = (event, properties = {}) => {
  try {
    if (window.posthog && typeof window.posthog.capture === "function") {
      window.posthog.capture(event, properties);
    }
  } catch {
    /* analytics must never break the page */
  }
  post(event, properties);
};
